import React from 'react';
import { useSelector } from 'react-redux';
import { SelectedRecordContainer } from '../../selectedRecordContainer/calendar/SelectedRecordContainer';

import '../SaveToContainer.scss';

/**
 * Container that houses the logic for either rending the search container (search box)
 * or the currently selected record.
 */

export const SaveToContainer = () => {
  const selectedRecord = useSelector((state) => state.calendar.selectedRecord);
  const isLoading = useSelector((state) => state.app.isLoading);

  return (
    <div className={isLoading ? 'saveToContainer-deactivated' : ''}>
      <div className="saveToContainer-header">Saved Location</div>
      <SelectedRecordContainer item={selectedRecord}/>
    </div>
  );
};
